define('shared/util/dispatchers/retrievers/form',['shared/lib/RSVP'], function(RSVP){
    'use strict';
    
    return function (key, options) {
        var $form = this.$el;
        return new RSVP.Promise(function(resolve){
            var $input = $form.find('input[name="' + key + '"]');
            var value;
            var resolveValue;
            if ($input.length <= 0) {
                resolve(null);
            }
            else {
                value = $input.val();
                resolveValue = value;
                if (options.allowEmpty === false && value === '') {
                    resolveValue = null;
                }
                resolve(resolveValue);
            }
        });
    };
});

